// Module
var code = "<div ng-if=\"$ctrl.match\" class=\"{{$ctrl.class}}\" ng-transclude></div>";
// Exports
module.exports = code;